'use strict';

var React = require('react');

var SvgYoutubeMinor = function SvgYoutubeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.86 7s-.14-.97-.56-1.4c-.53-.56-1.13-.56-1.4-.6-1.96-.14-4.9-.14-4.9-.14s-2.94 0-4.9.14c-.28.04-.87.04-1.4.6-.43.43-.56 1.4-.56 1.4s-.14 1.14-.14 2.28v1.07c0 1.14.14 2.28.14 2.28s.14.98.55 1.4c.54.56 1.24.55 1.55.6 1.12.11 4.76.15 4.76.15s2.94 0 4.9-.15c.27-.03.87-.04 1.4-.6.42-.42.56-1.4.56-1.4s.14-1.14.14-2.28v-1.07c0-1.14-.14-2.28-.14-2.28Zm-8.31 4.65v-3.96l3.78 1.98-3.78 1.98Z"
  }));
};
SvgYoutubeMinor.displayName = "YoutubeMinor";

exports.SvgYoutubeMinor = SvgYoutubeMinor;
